import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';

declare var AOS: any;

@Component({
  selector: 'app-for-consumers',
  templateUrl: './for-consumers.component.html',
  styleUrls: ['./for-consumers.component.scss'],
  standalone: false
})
export class ForConsumersComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'connected';

  sections = [
    { id: 'connected', label: 'Connected Car', icon: 'bx-car' },
    { id: 'safety', label: 'Safety & Alerts', icon: 'bx-shield-alt-2' },
    { id: 'rewards', label: 'Rewards', icon: 'bx-gift' },
    { id: 'store', label: 'Device Store', icon: 'bx-store' },
  ];

  ngOnInit() {}

  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
